import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getUserDetails,
  updateUser,
} from "../../redux/services/User Services/User.Services";
import { ActiveCategoryList } from "../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../redux/services/subCategoriesService/subCategories.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
const [formData, setFormData] = useState({
  category_id: "",
  subcategory_id: "",
  name: "",
  mobile: "",
  email: "",
  password: "",
  address: "",
  business_name: "",
  status: 1,
});
const permissionsList = [
  {
    label: "Employees",
    key: "employees",
    children: [
      { label: "Employee", key: "staff" },
      { label: "Roles", key: "role" },
      { label: "Departments", key: "department" },
      { label: "Activity", key: "StaffActivity" },
    ],
  },
  {
    label: "Leads",
    key: "lead",
    children: [
      { label: "New", key: "newlead" },
      { label: "Pending", key: "pendinglead" },
      { label: "Others", key: "alllead" },
      { label: "Assigned Lead", key: "LeadAssigned" },
    ],
  },
  {
    label: "Dashboard",
    key: "dashboard",
  },
  {
    label: "Inventory Management",
    key: "inventoryManagement",
    children: [
      { label: "Categories", key: "category" },
      { label: "Sub Categories", key: "subcategory" },

    ],
  },
  {
    label: "Task",
    key: "task",
  },
  {
    label: "Chat",
    key: "chat",
  },
  {
    label: "Reminder",
    key: "reminder",
  },
  {
    label: "Meeting",
    key: "meeting",
  },
  {
    label: "Leave",
    key: "leave",
  },
  {
    label: "Calendar",
    key: "calendar",
  },
  {
    label: "Content / Setting",
    key: "settings",
  },
];

const defaultPermissions = permissionsList.reduce((acc, item) => {
  acc[item.key] = 0;
  if (item.children) {
    item.children.forEach(child => {
      acc[child.key] = 0;
    });
  }
  return acc;
}, {});

  useEffect(() => {
  }, [id]);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        if (!id) {
          errorToast("Invalid User ID");
          return;
        }

        setLoading(true);
        const payload = {
          id: id
        }
        const res = await getUserDetails(payload);
        const data = res.data;
            // Merge permissions with defaults to ensure all keys exist
        const mergedPermissions = { ...defaultPermissions, ...data?.staff_permission };
     setFormData({
  id: data.id || "",
  name: data.name || "",
  mobile: data.mobile || "",
  email: data.email || "",
  password:data.simple_pass||"",
  business_name: data.business_name || "",
  address: data.address || "",
  status: data.status ?? 1,

  category_id: data.user_category?.category_id || "",
  subcategory_id: data.user_category?.sub_category_id || "",
    permissions: mergedPermissions,
});

        const categoryId = data.user_category?.category_id;

        if (categoryId) {
          const subRes = await ActiveSubCategoryList(categoryId);

          if (subRes?.success) {
            setSubCategories(subRes.data || []);
          } else if (subRes?.data?.success) {
            setSubCategories(subRes.data.data || []);
          }
        }
      } catch (error) {
        console.log(error);
        errorToast("Failed to load user data");
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [id]);
  useEffect(() => {
    getDropdownData();
  }, []);

  const getDropdownData = async () => {
    try {
      const res = await ActiveCategoryList();

      if (res?.success) {
        setCategories(res.data || []);
      }
    } catch (error) {
      console.log(error);
      errorToast("Failed to load categories");
    }
  };
  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      category_id: categoryId,
      subcategory_id: "",
    }));

    try {
      const res = await ActiveSubCategoryList(categoryId);

      if (res?.success) {
        setSubCategories(res.data || []);
      } else if (res?.data?.success) {
        setSubCategories(res.data.data || []);
      } else {
        setSubCategories([]);
      }
    } catch (error) {
      console.log(error);
      setSubCategories([]);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

 const handlePermissionTogglecheck = (key, children = []) => {
    setFormData((prev) => {
      const updatedPermissions = { ...prev.permissions };
      const isChecked = updatedPermissions[key] === 1 ? 0 : 1;

      // If it's a parent with children
      if (children.length > 0) {
        // Toggle parent
        updatedPermissions[key] = isChecked;

        // Toggle all children to match parent
        children.forEach((child) => {
          updatedPermissions[child.key] = isChecked;
        });
      } else {
        // It's a child - toggle it
        updatedPermissions[key] = isChecked;

        // Find the parent of this child and update it
        const parentItem = permissionsList.find(item =>
          item.children?.some(child => child.key === key)
        );

        if (parentItem) {
          // Check if ALL children are checked
          const allChildrenChecked = parentItem.children.every(
            child => updatedPermissions[child.key] === 1
          );

          // Check if ANY child is checked
          const anyChildChecked = parentItem.children.some(
            child => updatedPermissions[child.key] === 1
          );

          // If all children are checked, check the parent
          // If no children are checked, uncheck the parent
          if (allChildrenChecked) {
            updatedPermissions[parentItem.key] = 1;
          } else if (!anyChildChecked) {
            updatedPermissions[parentItem.key] = 0;
          }
        }
      }

      return {
        ...prev,
        permissions: updatedPermissions,
      };
    });
  };

  // SELECT ALL PERMISSIONS
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => {
      const updatedPermissions = { ...prev.permissions };

      // Update all permissions (both parent and child)
      Object.keys(updatedPermissions).forEach((key) => {
        updatedPermissions[key] = isChecked ? 1 : 0;
      });

      return {
        ...prev,
        permissions: updatedPermissions,
      };
    });
  };

  // Check if all permissions are selected
  const isAllSelected = () => {
    return Object.values(formData.permissions).every(val => val === 1);
  };

  // Check if any permission is selected
  const isAnySelected = () => {
    return Object.values(formData.permissions).some(val => val === 1);
  };

  // Get parent checkbox state for indeterminate state
  const getParentCheckState = (parentKey) => {
    const parentItem = permissionsList.find(item => item.key === parentKey);
    if (!parentItem?.children) return false;

    const children = parentItem.children;
    const checkedCount = children.filter(
      child => formData.permissions[child.key] === 1
    ).length;

    if (checkedCount === 0) return false;
    if (checkedCount === children.length) return true;
    return 'indeterminate';
  };


  // =========================
  // SUBMIT UPDATE
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();



    try {
      setLoading(true);
      const payload = {
        id: formData.id,
        name: formData.name,
          email: formData.email,
  password: formData.password,
        mobile: formData.mobile,
        business_name: formData.business_name,
        address: formData.address,
        status: formData.status,
        category_id: formData.category_id,
        subcategory_id: formData.subcategory_id,
      };



      const res = await updateUser(payload);

      if (res?.success === true) {
        successToast(res?.message || "user updated successfully");
        navigate("/user-list");
      } else {
        errorToast(res?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);

      if (
        error?.response?.data?.message &&
        typeof error.response.data.message === "object"
      ) {
        const validationErrors = error.response.data.message;
        setErrors(validationErrors);
        const allErrors = Object.values(validationErrors)
          .flat()
          .join(", ");
        errorToast(allErrors);
      } else {
        errorToast(
          error?.response?.data?.errors ||
          error?.response?.data?.message ||
          "Failed to update staff"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Edit Vendor</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Vendor</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() => navigate("/user-list")}
          >
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit} className="row g-3">
              <div className="col-md-6">
                <label>Name</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`form-control custumform ${errors?.name ? "is-invalid" : ""}`}
                />
                {errors?.name && (
                  <div className="invalid-feedback">
                    {errors.name[0]}
                  </div>
                )}
              </div>
<div className="col-md-6">
  <label>Email</label>
  <input
    type="email"
    name="email"
    value={formData.email}
    onChange={handleChange}
    className={`form-control custumform ${
      errors?.email ? "is-invalid" : ""
    }`}
  />

  {errors?.email && (
    <div className="invalid-feedback">
      {errors.email[0]}
    </div>
  )}
</div>

              {/* MOBILE */}
              <div className="col-md-6">
                <label>Mobile</label>
                <input
                  name="mobile"
                  value={formData.mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setFormData((prev) => ({
                      ...prev,
                      mobile: value,
                    }));
                    if (errors.mobile) {
                      setErrors((prev) => ({
                        ...prev,
                        mobile: null,
                      }));
                    }
                  }}
                  className={`form-control custumform ${errors?.mobile ? "is-invalid" : ""}`}
                  maxLength={10}
                />
                {errors?.mobile && (
                  <div className="invalid-feedback d-block">
                    {errors.mobile[0]}
                  </div>
                )}
              </div>
<div className="col-md-6">
  <label>Password</label>

  <div className="position-relative">
    <input
      type={showPassword ? "text" : "password"}
      name="password"
      value={formData.password}
      onChange={handleChange}
      placeholder="Enter new password (optional)"
      className={`form-control custumform ${
        errors?.password ? "is-invalid" : ""
      }`}
      style={{ paddingRight: "40px" }}
    />

    <span
      onClick={() => setShowPassword((prev) => !prev)}
      style={{
        position: "absolute",
        right: "12px",
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
      }}
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </span>
  </div>

  {errors?.password && (
    <div className="invalid-feedback d-block">
      {errors.password[0]}
    </div>
  )}
</div>
              <div className="col-md-6">
                <label>
                  Category
                </label>
                <select
                  name="category_id"
                  value={formData.category_id}
                  onChange={handleCategoryChange}
                  className="form-control custumform"
                >
                  <option value="">Select Category</option>
                  {categories.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label>
                  Sub Category
                </label>
                <select
                  name="subcategory_id"
                  value={formData.subcategory_id}
                  onChange={handleChange}
                  className="form-control custumform"
                >
                  <option value="">Select Sub Category</option>
                  {subCategories.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label>Business Name</label>
                <input
                  name="business_name"
                  value={formData.business_name}
                  onChange={handleChange}
                  className={`form-control custumform ${errors?.business_name ? "is-invalid" : ""}`}
                />
                {errors?.business_name && (
                  <div className="invalid-feedback">
                    {errors.business_name[0]}
                  </div>
                )}
              </div>
              {/* STATUS */}
              <div className="col-md-6">
                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>

              {/* JOINING DATE */}
              {/* <div className="col-md-6">
                <label>Joining Date</label>
                <input
                  type="date"
                  name="joining_date"
                  value={formData.joining_date}
                  onChange={handleChange}
                  className={`form-control custumform ${errors?.joining_date ? "is-invalid" : ""}`}
                />
                {errors?.joining_date && (
                  <div className="invalid-feedback d-block">
                    {errors.joining_date[0]}
                  </div>
                )}
              </div> */}

              {/* ADDRESS */}
              {/* <div className="col-md-12">
                <label>Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  rows="3"
                  className={`form-control custumform ${errors?.address ? "is-invalid" : ""}`}
                />
                {errors?.address && (
                  <div className="invalid-feedback d-block">
                    {errors.address[0]}
                  </div>
                )}
              </div> */}



              {/* SUBMIT */}
                 <div className="row">
                  {permissionsList.map((item) => (
                    <div key={item.key} className="col-md-4 mb-4">
                      <div className="card shadow-sm border-0">

                        {/* Header / Parent Permission */}
                        <div className="card-header bg-light d-flex align-items-center">
                          <div className="form-check m-0 w-100">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`perm-${item.key}`}
                              checked={formData.permissions[item.key] === 1}
                              ref={(el) => {
                                if (el && item.children) {
                                  const state = getParentCheckState(item.key);
                                  el.indeterminate = state === "indeterminate";
                                }
                              }}
                              onChange={() =>
                                handlePermissionTogglecheck(item.key, item.children || [])
                              }
                            />
                            <label
                              className="form-check-label fw-bold  ms-2"
                              htmlFor={`perm-${item.key}`}
                            >
                              {item.label}
                            </label>
                          </div>
                        </div>

                        {/* Body / Children Permissions */}
                        {item.children?.length > 0 && (
                          <div className="card-body py-2">
                            <div className="ps-2 border-start">
                              {item.children.map((child) => (
                                <div key={child.key} className="form-check mb-2">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`perm-${child.key}`}
                                    checked={formData.permissions[child.key] === 1}
                                    onChange={() =>
                                      handlePermissionTogglecheck(child.key, [])
                                    }
                                  />
                                  <label
                                    className="form-check-label text-light ms-2"
                                    htmlFor={`perm-${child.key}`}
                                  >
                                    {child.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              <div className="col-12 text-end">
                <button
                  type="submit"
                  className="add-btn"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update User"}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditUser;